import { number, object, string, } from 'yup';
const formSpec = {
    email: string()
        .required('This field is required')
        .email('Please enter a valid email address'),
    password: string().required('This field is required'),
};
const childFormSpec = {
    contactId: number()
        .required('Please select an account'),
};
export const loginFormSchema = object(formSpec);
export const childFormSchema = object(childFormSpec);
